export default {
  getRubriqueDepenseById: state => id => {
    return state.rubriques.find((r) => r._id === id).length ? state.rubriques.find((r) => r._id === id) : []
  }
}